module.exports = require("crypto-random-string");